import { render } from "./BaseLayoutModifier.vue?vue&type=template&id=4899914f"
import script from "./BaseLayoutModifier.vue?vue&type=script&lang=js"
export * from "./BaseLayoutModifier.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/app-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__